import { RotatingLines } from "react-loader-spinner";
import {
  EMPTY_STRING,
  invoiceConstants,
  buttonNameConstants,
  buttonTypeConstants,
  toggleSwitchButtonConstants,
} from "../../../constants";
import SimpleNumberField from "../../components/inputNumberField/SimpleNumberField";
import SelectDropDown from "../../components/selectDropdown/SelectDropdown";
import TableCustomHeader from "../../components/table/TableCustomHeader";
import {
  batchStockPriceChange,
  excludeNullColumns,
  getBatchModalCogsColumn,
  getBatchModalGradeColumn,
  getBatchModalQuantityColumn,
  getBatchModalRarityColumn,
  getModalStockPriceColumn,
  getProductIfExist,
  getProductSubCategory,
  handleBatchProductDelete,
  handleEmptyOnFocus,
  handleLockOrUnlockTradeItem,
  handleShowNintendoCondition,
  isMarketPriceHigh,
  isStoreCustomProduct,
  onChangeProductCondition,
  parseToDecimalNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";
import { TRADING_CARD_CATEGORIES_ENUMS } from "../../../system/globalEnums";
import {
  EditIcon,
  ShowIcon,
  LockIcon,
  UnLockIcon,
  DeleteIcon,
  FulfillIcon,
  ActionDotsIcons,
} from "../../../assets/icons/iconsProvider";
import { Button, ClickableTooltip } from "../../components";
import DropdownSkeleton from "../../Skeletons/DropdownSkeleton/DropdownSkeleton";

const getAddInvoiceColumns = (props) => {
  const {
    productTags,
    currentStore,
    tradeinMargin,
    markupPresets,
    handleEditCardClick,
    invoiceBatchInventory,
    setInvoiceBatchInventory,
  } = props;
  let columns = [
    {
      id: "title",
      name: "Title",
      selector: (row) => row.productName,
      cell: (row) => {
        return (
          <div className="d-flex flex-column">
            <TableCustomHeader
              id={`tool${row.id}`}
              label={
                <span className="inventory-cell-max-size product-title-max-width">
                  {row.productName}
                </span>
              }
              tooltopText={row.productName}
            />
            {getProductSubCategory(row.genre) ===
              TRADING_CARD_CATEGORIES_ENUMS.SYSTEM &&
              (currentStore[
                toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
              ] ||
                row?.serialNumber) && (
                <span
                  className={`${
                    row.serialNumber ? EMPTY_STRING : "text-danger"
                  } batch-seial-number-label`}
                >
                  S/N : {row?.serialNumber || "Required"}
                </span>
              )}
          </div>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalGradeColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      currentStore
    ),
    {
      id: "condition",
      name: "Condition",
      selector: (row) => row.productCondition,
      cell: (row) => {
        return (
          <SelectDropDown
            menuPlacement="bottom"
            options={row.productConditionList}
            noOptionsMessage="No Type Found"
            placeHolder="Type"
            defaultPageSize={{
              value: row?.productCondition,
              label: handleShowNintendoCondition(
                row.consoleName,
                row?.productCondition
              ),
            }}
            handleChange={(e) =>
              onChangeProductCondition(
                markupPresets,
                row.id,
                e.value,
                false,
                invoiceBatchInventory,
                setInvoiceBatchInventory,
                tradeinMargin
              )
            }
            isDisabled={row?.isItemLocked}
            menuPortalTarget=""
            value={{
              value: row?.productCondition,
              label: handleShowNintendoCondition(
                row.consoleName,
                row?.productCondition
              ),
            }}
          />
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalRarityColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      currentStore?.id,
      markupPresets,
      tradeinMargin
    ),
    {
      id: "type",
      name: "Type",
      selector: (row) => row.productType,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.productType}</span>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "8%",
    },
    {
      id: "category",
      name: "Category",
      selector: (row) => row.consoleName,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.consoleName}</span>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "marketPrice",
      name: "Market Price",
      selector: (row) => row.marketPrice,
      cell: (row) => {
        return (
          <span
            className={`inventory-cell-max-size ${
              isMarketPriceHigh(
                row.marketPrice,
                row.inStockPrice,
                productTags,
                isStoreCustomProduct(row, "apiSource")
                  ? row.tags
                  : row.tags.map((tag) => tag.label),
                row.isDataFetching,
                isStoreCustomProduct(row, "apiSource")
              )
                ? "text-danger"
                : ""
            }`}
          >
            {parseToThousandSeperatorDecimalNumber(row.marketPrice)}
          </span>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "9%",
    },
    getBatchModalQuantityColumn(
      currentStore,
      invoiceBatchInventory,
      setInvoiceBatchInventory
    ),
    getBatchModalCogsColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      handleEmptyOnFocus
    ),
    getModalStockPriceColumn(
      currentStore,
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      productTags,
      handleEmptyOnFocus,
      markupPresets,
      { width: "8%" }
    ),
    {
      id: "inStockPriceAnd",
      name: "",
      cell: (row) => {
        return getProductIfExist(row, (value, id) => {
          batchStockPriceChange(
            id,
            value,
            currentStore,
            markupPresets,
            invoiceBatchInventory,
            setInvoiceBatchInventory
          );
        });
      },
      sortable: false,
      width: "7%",
    },
    {
      id: "action",
      name: "",
      cell: (row) => {
        return row?.isDataFetching ? (
          <div className="d-flex justify-content-center align-items-center">
            <RotatingLines
              visible={true}
              height="20"
              width="20"
              color="grey"
              strokeColor="#6a18ed"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
            />
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper"
              onClick={() =>
                handleBatchProductDelete(
                  row.id,
                  invoiceBatchInventory,
                  setInvoiceBatchInventory
                )
              }
            >
              <DeleteIcon className="cursor-pointer text-primary" />
            </button>
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper  ps-0 pe-0 mx-auto"
              onClick={() => {
                handleLockOrUnlockTradeItem(
                  currentStore,
                  invoiceBatchInventory,
                  setInvoiceBatchInventory,
                  row.id
                );
              }}
            >
              {row?.isItemLocked ? (
                <LockIcon className="cursor-pointer text-primary" />
              ) : (
                <UnLockIcon className="cursor-pointer " />
              )}
            </button>
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper ps-0 pe-0"
              onClick={() => {
                handleEditCardClick(row);
              }}
            >
              <EditIcon className="cursor-pointer text-primary" />
            </button>
          </div>
        );
      },
      sortable: false,
      width: "8%",
    },
  ];
  let filteredColumns = excludeNullColumns(columns);
  return filteredColumns;
};

const actionCellRendererInvoice = ({
  params,
  tooltipRef,
  handleFulfillInvoice,
  handleEditInvoice,
  handleDeleteInvoice,
  handleViewInvoiceModal,
  gridState,
}) => {
  let actionComponent = <></>;
  if (!params?.data?.id) {
    actionComponent = <DropdownSkeleton width="5em" height="1.5em" />;
  }

  const isDraft = params.data.invoiceType === invoiceConstants.DRAFT;
  const isFulfilled = params.data.invoiceType === invoiceConstants.FULFILLED;

  if (!isDraft && !isFulfilled) return actionComponent;

  actionComponent = (
    <div
      onMouseLeave={() => {
        tooltipRef.current?.close();
      }}
    >
      <ClickableTooltip
        anchorSelect={`#tool${params.data.id}`}
        openOnClick={true}
        tooltipRef={tooltipRef}
        appendTo={document.body}
      >
        {isDraft && (
          <>
            <Button
              label={buttonNameConstants.FULFILL_INVOICE}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={FulfillIcon}
              handleClick={() => handleFulfillInvoice(params, gridState)}
            />

            <Button
              className="w-100"
              IconImage={EditIcon}
              label={buttonNameConstants.EDIT}
              handleClick={() => handleEditInvoice(params)}
              buttonType={buttonTypeConstants.ACTION_BUTTON}
            />

            <Button
              className="w-100"
              IconImage={DeleteIcon}
              label={buttonNameConstants.DELETE}
              handleClick={() => handleDeleteInvoice(params)}
              buttonType={buttonTypeConstants.ACTION_BUTTON}
            />
          </>
        )}

        {isFulfilled && (
          <Button
            className="w-100"
            IconImage={ShowIcon}
            label={buttonNameConstants.VIEW_INVOICE}
            handleClick={() => handleViewInvoiceModal(params)}
            buttonType={buttonTypeConstants.ACTION_BUTTON}
          />
        )}
      </ClickableTooltip>

      <button
        id={`tool${params.data.id}`}
        className="action-Button-Wrapper"
        onClick={() => {
          tooltipRef.current?.isOpen
            ? tooltipRef.current.close()
            : tooltipRef.current.open({
                anchorSelect: `tool${params.data.id}`, // ✅ FIXED
              });
        }}
      >
        <ActionDotsIcons className="cursor-pointer" />
      </button>
    </div>
  );

  return actionComponent;
};

export { getAddInvoiceColumns, actionCellRendererInvoice };
